import $ from 'jquery';
var stickyNav = $('#navbar').offset().top;

$(window).on('scroll', function() {
    if($(window).scrollTop() > stickyNav) {
        $('#navbar').removeClass('position-relative position-sm-absolute');

        if($('body').hasClass('admin-bar')) {
            $('#navbar').addClass('position-fixed t-32');
        } else {
            $('#navbar').addClass('position-fixed t-0');
        }
    }
    else {
        $('#navbar').removeClass('position-sm-fixed position-fixed t-0 t-32');
        $('#navbar').addClass('position-relative position-sm-absolute');
    }  
});